module.exports = __webpack_public_path__ + "img/nt118-07-81-1.prt.66924099.jpg";